import { useUserState } from '../auth/UserState';

export default function useIsOperator() {
  const { authClaims } = useUserState();
  return authClaims?.admin === true;
}
